enum EstadosModalEntradaInventario {
    CERRADO = 'CERRADO',
    CREACION = 'CREACION',
    EDICION = 'EDICION',
    VISUALIZACION = 'VISUALIZACION',
}

export { EstadosModalEntradaInventario };
